<h1 mat-dialog-title>Mark as Passed</h1>
<div mat-dialog-content>
    <p>Mark <strong>{{ data.guestName }}</strong> as passed?</p>
    <p class="mt-2">This changes the screening result to Pass and, for AutoHost screenings, approves the reservation in AutoHost.</p>
</div>
<div mat-dialog-actions class="mt-3">
    <button mat-button data-test="cancel-pass" (click)="onActionClick(false)">Cancel</button>
    <button mat-raised-button class="action-button" data-test="confirm-pass" (click)="onActionClick(true)">Mark as Passed</button>
</div>
